// extracted by mini-css-extract-plugin
export var nav = "navbar-module--nav--kd1Tb";
export var fullmenu = "navbar-module--fullmenu--JsdbD";
export var dksku = "navbar-module--dksku--YhGVi";
export var menubtnContainer = "navbar-module--menubtnContainer--isFYx";
export var menubtn = "navbar-module--menubtn--k9QWt";
export var closebtn = "navbar-module--closebtn--Kd-I1";
export var links = "navbar-module--links--CIZ1n";
export var mobsku = "navbar-module--mobsku--iCxd2";
export var title = "navbar-module--title--8aa1j";